// Chakra imports
import React from "react";
import ReactQuill from "react-quill";

export default class Editor extends React.Component {
  constructor(props) {
    super(props);
    this.state = { editorHtml: this.props.placeholder };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(html) {
    this.setState({ editorHtml: html });
    if (this.props.onChange) {
      this.props.onChange(html);
    }
  }

  render() {
    return (
      <div className="text-editor">
        <ReactQuill
          value={this.state.editorHtml}
          onChange={this.handleChange}
          placeholder={""}
          modules={Editor.modules}
          formats={Editor.formats}
        />
      </div>
    );
  }
}

Editor.modules = {
  toolbar: [
    ["bold", "italic", "underline", "strike"],
    ["blockquote"],
    [{ header: 1 }, { header: 2 }],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ script: "sub" }, { script: "super" }],
    [{ indent: "-1" }, { indent: "+1" }],
    [{ direction: "rtl" }],
    [{ size: ["small", false, "large", "huge"] }],
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ color: [] }, { background: [] }],
    [{ font: [] }],
    [{ align: [] }],
    ["clean"],
    ["link"],
  ],
  clipboard: {
    matchVisual: true,
  },
};

Editor.formats = [
  "header",
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "script",
  "direction",
  "color",
  "background",
  "font",
  "align",
  "clean",
  "link",
  "image",
  "video",
];
